import { render, staticRenderFns } from "./CabinetFolderFileControlDialogComponent.vue?vue&type=template&id=45289d0d&scoped=true&"
import script from "./CabinetFolderFileControlDialogComponent.vue?vue&type=script&lang=js&"
export * from "./CabinetFolderFileControlDialogComponent.vue?vue&type=script&lang=js&"
import style0 from "./CabinetFolderFileControlDialogComponent.vue?vue&type=style&index=0&id=45289d0d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45289d0d",
  null
  
)

export default component.exports